import axios from "axios"
import { useState } from "react"
import { get_property_reports_traffic } from "../../api/api"
import queryString from 'query-string'


const FilterReportCategories = ({ queries, setData, active, mode }) => {

    const [isLoading, setIsLoading] = useState(false)

    const handleOnClick = async (e) => {
        try {
            setData({})
            setIsLoading(true)
            const res = await axios.get(get_property_reports_traffic(queryString.stringify(queries), 2, active))
            setData({ type: 3, data: { categories: res.data }, mode: mode })
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }



    return (
        <>
            <button
                disabled={isLoading}
                className={`moreFiltersButton ${active?.primarySubjectCategoryId ? 'active' : ''} ${mode ? 'chartModeBtn' : ''}`}
                type="button"
                onClick={handleOnClick}>{isLoading ? '...' : 'دسته بندی'}
                {!isLoading && active?.primarySubjectCategoryId ? ': ' + active.primarySubjectCategoryId?.name : ''}
            </button>
        </>
    );
}

export default FilterReportCategories;